import { render } from "./product-badge.vue?vue&type=template&id=3c114180"
import script from "./product-badge.vue?vue&type=script&lang=js"
export * from "./product-badge.vue?vue&type=script&lang=js"

import "./product-badge.vue?vue&type=style&index=0&id=3c114180&lang=scss"

import exportComponent from "/buddy/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__